<template>
    <div class="left-menu">
        <div class="title">
            {{ $t('title') }}
        </div>
        <div class="item" :class="current == 'dayprediction' ? 'text-prime-400' : ''">
            <router-link :to="{ name: 'dayprediction' }">
                <IconNews height="24" />
                <div>{{ $t('prediction') }}</div>
            </router-link>
        </div>
        <div class="item" :class="current == 'calendar' ? 'text-prime-400' : ''">
            <router-link :to="{ name: 'calendar' }">
                <IconCalendar height="24"  />
                <div>{{ $t('calendar') }}</div>
            </router-link>
        </div>
        <div class="item" :class="current == 'panchanga' ? 'text-prime-400' : ''">
            <router-link :to="{ name: 'panchanga' }">
                <IconGraph height="24"  />
                <div>{{ $t('panchanga') }}</div>
            </router-link>
        </div>
        <div class="item" :class="current == 'support' ? 'text-prime-400' : ''">
            <router-link :to="{ name: 'support' }">
                <SupportSign class="w-6 h-6" />
                <div>{{ $t('support') }}</div>
            </router-link>
        </div>
        <div class="item" :class="current == 'profile' || current == 'settings' ? 'text-prime-400' : ''">
            <router-link :to="{ name: loggedIn ? 'profile' : 'settings' }">
                <IconSettings height="24"  />
                <div>{{ $t('settings') }}</div>
            </router-link>
        </div>
    </div>
</template>

<script>
import IconSettings from '@/components/visual/icons/IconSettings'
import IconNews from '@/components/visual/icons/IconNews'
import IconGraph from '@/components/visual/icons/IconGraph'
import IconCalendar from '@/components/visual/icons/IconCalendar'
import SupportSign from '@/components/visual/SupportSign'
import { mapGetters } from 'vuex'
export default {
    components: { IconSettings, IconNews, IconGraph, IconCalendar, SupportSign, },
    computed: {
        current() {
            return this.$route.name
        },
        ...mapGetters('auth', {
            loggedIn: 'loggedIn',
        }),
    }
}
</script>

<i18n locale="ru" lang="yaml">
    title: "Лундарь"
    prediction: "Прогноз"
    panchanga: "Панчанга"
    calendar: "Календарь"
    support: "Поддержка"
    settings: "Настройки"
</i18n>

<i18n locale="en" lang="yaml">
    title: "Moondar"
    prediction: "Prediction"
    panchanga: "Panchanga"
    calendar: "Calendar"
    support: "Support"
    settings: "Settings"
</i18n>
